<template>
  <div v-if="dataIsLoad" class="addon">
    <ul class="addon-list">
      <li
        v-for="(item, index) in addonData"
        :key="item.CustomMarketID_withoutSize"
        class="addon-list-item"
      >
        <a class="addon-img" @click.prevent="getItemDetail(item.CustomMarketID_withoutSize)">
          <img class="img-fluid" :src="renderPic(item.Cover, '_w100_h100')" :alt="item.Name" />
        </a>
        <div class="addon-info">
          <a class="item-name" @click.prevent="getItemDetail(item.CustomMarketID_withoutSize)">
            {{ item.Name }}
          </a>
          <div class="item-price">
            <span class="sell-price">NT$ {{ item.SellPrice }}</span>
            <span v-if="item.OriginPrice !== item.SellPrice" class="origin-price">
              NT$ {{ item.OriginPrice }}
            </span>
          </div>
          <div class="addon-shop-select">
            <select
              v-if="!hasMainItem"
              class="form-control spec-select"
              @click.prevent="checkAddonInCart"
            >
              <option value="">請選擇規格</option>
            </select>
            <select
              v-else
              class="form-control spec-select"
              @change="selectSpec($event, item, index)"
            >
              <option value="">請選擇規格</option>
              <option
                v-for="spec in item.Specs"
                :key="spec.CustomMarketID"
                :disabled="!spec.HasStock"
                :value="spec.CustomMarketID"
              >
                {{ spec.ColorName }}-{{ spec.Size }} {{ !spec.HasStock ? '(已售完)' : '' }}
              </option>
            </select>
            <div v-if="!hasMainItem" class="UiQuantity count-select">
              <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="checkAddonInCart">
                –
              </a>
              <span class="UiQuantity__text">1</span>
              <a class="UiQuantity__btn UiQuantity__btn--plus" @click.prevent="checkAddonInCart">
                ＋
              </a>
            </div>
            <div v-else class="UiQuantity count-select">
              <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="onMinus(index)">
                –
              </a>
              <span class="UiQuantity__text">{{ selectedCount[index] }}</span>
              <a class="UiQuantity__btn UiQuantity__btn--plus" @click.prevent="onPlus(index)">
                ＋
              </a>
            </div>
            <button v-if="!hasMainItem" class="btn addon-add" @click.prevent="checkAddonInCart">
              Add
            </button>
            <button v-else class="btn addon-add" @click.prevent="addToCart(index)">Add</button>
          </div>
          <div class="addon-shop-select-medium">
            <select
              v-if="!hasMainItem"
              class="form-control spec-select"
              @click.prevent="checkAddonInCart"
            >
              <option disabled value="">請選擇規格</option>
            </select>
            <select
              v-else
              class="form-control spec-select"
              @change="selectSpec($event, item, index)"
            >
              <option value="">請選擇規格</option>
              <option
                v-for="spec in item.Specs"
                :key="spec.CustomMarketID"
                :disabled="!spec.HasStock"
                :value="spec.CustomMarketID"
              >
                {{ spec.ColorName }}-{{ spec.Size }} {{ !spec.HasStock ? '(已售完)' : '' }}
              </option>
            </select>
            <div v-if="!hasMainItem" class="UiQuantity count-select">
              <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="checkAddonInCart">
                –
              </a>
              <span class="UiQuantity__text">1</span>
              <a class="UiQuantity__btn UiQuantity__btn--plus" @click.prevent="checkAddonInCart">
                ＋
              </a>
            </div>
            <div v-else class="UiQuantity count-select">
              <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="onMinus(index)">
                –
              </a>
              <span class="UiQuantity__text">{{ selectedCount[index] }}</span>
              <a class="UiQuantity__btn UiQuantity__btn--plus" @click.prevent="onPlus(index)">
                ＋
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import Slick from '@global/vendors/vue-slick';
import ShopAddonItemsTmpl from '@page/cart/template/shopAddonItemsTmpl.pug';
import imgTransfer from '@global/helpers/imgTransfer';
import MessageBox from '@global/helpers/messageBox';
import utmKDetect, { shareCode } from '@global/helpers/utmKDetect';
import store from '@global/components/store/index';
import $ from 'jquery';
import AlertDialog from '@global/helpers/alertDialog';
import { createNamespacedHelpers } from 'vuex';
import { fireAddToCart } from '@global/gtm/common';

const { mapActions } = createNamespacedHelpers('miniCartModule');
export default {
  name: 'AddonItems',
  props: ['addonData', 'dataIsLoad', 'hasMainItem', 'customSlick'],
  store,
  data() {
    return {
      selectedCustomMarketID: this.addonData.map(() => ''),
      selectedCount: this.addonData.map(() => 1),
      selectIsOpen: false,
      shareCode,
    };
  },
  computed: {
    /**
     * 取得加價購商品各規格的庫存數量
     */
    stockArray() {
      const stockArr = [];
      this.addonData.forEach((item) => {
        const specStockCount = [];
        item.Specs.forEach((spec) => {
          specStockCount.push({
            customMarketID: spec.CustomMarketID,
            stock: spec.Stock,
          });
        });
        stockArr.push(specStockCount);
      });
      return stockArr;
    },
  },
  mounted() {
    if (this.type === 'shoppingCart') {
      $('.addon-slide').not('.slick-initialized').slick(window.cartAddonSlide);
    }
    if (this.customSlick === true) {
      $('.addon-slide').not('.slick-initialized').slick(window.cartAddonSlide);
    }
  },

  methods: {
    ...mapActions(['getCartInfo']),
    getItemDetail(customMarketID) {
      axios
        .get(`${API_URL.MARKET_CONTENT}`, {
          params: {
            CustomMarketID: `${customMarketID}SZ_`,
          },
        })
        .then((res) => {
          this.$emit('showPopupDetail', {
            detailData: res.data.Response,
          });
        })
        .catch(() => {
          AlertDialog.alert('系統忙線中,請稍後再試', () => {
            window.location.href = '/';
          });
        });
    },
    addToCart(idx) {
      if (this.selectedCustomMarketID[idx] === '') {
        AlertDialog.alert('請選擇規格');
        return;
      }

      const utmData =
        utmKDetect(this.selectedCustomMarketID[idx].CustomMarketID) !== null
          ? utmKDetect(this.selectedCustomMarketID[idx].CustomMarketID)
          : '';

      const shareCode = this.shareCode() === null ? null : this.shareCode();

      axios
        .post(`${API_URL.SHOPPING_CART}`, {
          CustomMarketID: this.selectedCustomMarketID[idx].CustomMarketID,
          Count: this.selectedCount[idx],
          UtmTag: utmData,
          ShareCode: shareCode,
        })
        .then((res) => {
          if (res.data.Code === 200 || res.data.Code === 406) {
            MessageBox.cart('加入購物車');
            this.getCartInfo();

            fireAddToCart({
              item_id: this.selectedCustomMarketID[idx].CustomMarketID.split('SZ')[0],
              item_name: this.addonData[idx].Name,
              index: 0,
              affiliation: this.selectedCustomMarketID[idx].ColorName,
              item_brand: this.selectedCustomMarketID[idx].Size,
              item_list_name: '產品內頁加價購',
              price: this.addonData[idx].SellPrice,
              quantity: this.selectedCount[idx],
              item_variant: '',
            });
          } else if (res.data.Code === 205) {
            AlertDialog.alert('商品已售完', () => {
              window.location.reload();
            });
          } else {
            AlertDialog.alert(res.data.Message);
          }
        });
    },
    renderPic(picUrl, sizeStr) {
      return imgTransfer(picUrl, sizeStr);
    },
    showCartDialog(customMarketID) {
      this.$emit('showCartDialog', customMarketID);
    },
    onMinus(index) {
      if (this.selectedCount[index] <= 1) return;
      this.$set(this.selectedCount, index, this.selectedCount[index] - 1);
    },
    onPlus(index) {
      if (this.selectedCustomMarketID[index] === '') {
        AlertDialog.alert('請選擇商品規格');
        return;
      }

      const itemStock = this.stockArray[index].find(
        (item) => item.customMarketID === this.selectedCustomMarketID[index].CustomMarketID,
      );

      if (this.selectedCount[index] >= itemStock.stock) return;
      if (this.selectedCount[index] >= 10) return;
      this.$set(this.selectedCount, index, this.selectedCount[index] + 1);
    },
    openSelector() {
      this.selectIsOpen = !this.selectIsOpen;
    },
    checkAddonInCart() {
      this.$emit('showAddonWarnText');
    },
    selectSpec(event, item, itemIndex) {
      const findSpec = item.Specs.find((spec) => spec.CustomMarketID === event.target.value) || '';

      this.$set(this.selectedCustomMarketID, itemIndex, findSpec);
    },
  },
  template: ShopAddonItemsTmpl,
};
</script>

<style></style>
